import React, { useEffect, useState } from 'react'
import Localizacao from '../Components/Localizacao'
import Campanha from '../Components/Campanha'
import Parametros from '../Components/Parametros'
import RefinanciamentoPortabilidade from '../Components/RefinanciamentoPortabilidade'
import BancosPagadores from '../Components/BancosPagadores'
import MaisInformacoes from '../Components/MaisInformacoes'
import SimpleCard from 'components/SimpleCard'
import classNames from 'classnames'
import useRedux from 'hooks/useRedux'
import * as campanhaActions from 'store/modules/backoffice/campanha/actions'
import * as yup from 'yup'
import { Tab, Ul } from 'components/SimpleTab/style'
import { Col, Row, TabContent, TabPane } from 'reactstrap'
import { CustomButton } from 'styles/global'
import { ApplicationState } from 'store'
import { CAMPANHA } from 'store/modules/backoffice/campanha/types'
import { useSelector } from 'react-redux'
import {
  schemaTab1,
  schemaTab2,
  schemaTab3,
  schemaTab4,
  schemaTab5,
  schemaTab6
} from '../constants/schemas'
import { toast } from 'react-toastify'
import { removeMaskMoney } from 'util/masks'
import Discador from '../Components/Discador'
import ModalAprovacaoClientes from 'components/ModalAprovacaoClientes/index'
import ModalConfirmacao from 'components/ModalConfirmacao'
import ElevenLabs from '../Components/ElevenLabs'

const Register = () => {
  const {
    activeTabRegister,
    activeTab,
    register,
    tiposCampanha,
    visualizacao,
    modalAprovacaoClientes,
    previaClientesPorLoja,
    totalClientesPrevia
  } = useSelector<ApplicationState, CAMPANHA>((state) => state.campanha)

  const { dispatch } = useRedux()
  const tipoElevenLabsId = '58dbb40f-ff45-4a29-8375-fcc9bb726d1f'
  const tipoDiscadorId = 'dfb8fbbe-d7b8-45d9-badf-7e1e18c943f9'
  const tipoUraId = 'd38a3f12-927f-4936-8eee-6552ce2ed81e'

  const tipoCampanhaSelecionada = tiposCampanha.find(
    (item) => item.id === register.tipoCampanhaCrmId
  )
  const descricaoTipoCampanhaSelecionada =
    tipoCampanhaSelecionada?.descricao?.trim().toUpperCase() || ''
  const isTipoDiscadorOuUra =
    register.tipoCampanhaCrmId === tipoDiscadorId ||
    register.tipoCampanhaCrmId === tipoUraId ||
    descricaoTipoCampanhaSelecionada === 'DISCADOR' ||
    descricaoTipoCampanhaSelecionada === 'URA'
  const isTipoElevenLabs =
    register.tipoCampanhaCrmId === tipoElevenLabsId ||
    descricaoTipoCampanhaSelecionada === 'ELEVENLABS'

  const isEdicaoCampanhaElevenLabs =
    !!register.id && register.tipoCampanhaCrmId === tipoElevenLabsId

  const [
    showConfirmacaoParcialSemClientes,
    setShowConfirmacaoParcialSemClientes
  ] = useState(false)

  const temClientesDisponiveis = previaClientesPorLoja.some(
    (item) => Number(item?.quantidadeClientes ?? 0) > 0
  )
  const temLojasOuGruposSemClientes = previaClientesPorLoja.some(
    (item) => Number(item?.quantidadeClientes ?? 0) <= 0
  )
  const todosSemClientes = !temClientesDisponiveis
  const possuiPreviaMista =
    temClientesDisponiveis && temLojasOuGruposSemClientes

  useEffect(() => {
    if (activeTab === 'register') {
      dispatch(campanhaActions.getBancosPagadoresSaga())
      dispatch(campanhaActions.getTiposCampanhaSaga())
    }
  }, [dispatch, activeTab])

  useEffect(() => {
    if (activeTabRegister === 5 && !isTipoDiscadorOuUra) {
      dispatch(campanhaActions.setActiveTabRegister(1))
    }

    if (activeTabRegister === 6 && !isTipoElevenLabs) {
      dispatch(campanhaActions.setActiveTabRegister(1))
    }
  }, [activeTabRegister, isTipoDiscadorOuUra, isTipoElevenLabs, dispatch])

  function cleanAllInvalids() {
    dispatch(campanhaActions.cleanInvalidsTabDadosGerais())
    dispatch(campanhaActions.cleanInvalidsTabParametros())
    dispatch(campanhaActions.cleanInvalidsTabBancos())
    dispatch(
      campanhaActions.cleanInvalidsTabRefinsetInvalidsTabRefinPortabilidade()
    )
    dispatch(campanhaActions.cleanInvalidsTabDiscador())
  }

  function onSave() {
    cleanAllInvalids()

    schemaTab1
      .validate(
        {
          id: register.id,
          descricao: register.descricao,
          cliente: register.cliente,
          basePropria: register.basePropria,
          carteira: register.carteira,
          empresasGrupo: register.empresasGrupo,
          tipoCampanhaCrmId: register.tipoCampanhaCrmId,
          tipoOperacaoId: register.tipoOperacaoId,
          dataInicioCampanha: register.dataInicioCampanha,
          dataFimCampanha: register.dataFimCampanha,
          quantidadeClientes: register.quantidadeClientes,
          ufCampanha: register.ufCampanha,
          cidadeCampanha: register.cidadeCampanha
        },
        { abortEarly: false }
      )
      .then(() => {
        const quantidadeInicialSalario = register.quantidadeInicialSalario
          ? Number(removeMaskMoney(register.quantidadeInicialSalario))
          : null
        const quantidadeFinalSalario = register.quantidadeFinalSalario
          ? Number(removeMaskMoney(register.quantidadeFinalSalario))
          : null

        schemaTab2
          .validate(
            {
              redudancia: register.redudancia,
              ignorarClientesCarteira: register.carteira,
              indisponibilidade: register.indisponibilidade,
              naoPerturbe: register.naoPerturbe,
              telefone: register.telefone,
              idadeInicial: register.idadeInicial,
              idadeFinal: register.idadeFinal,
              formaRecebimentoBeneficio: register.formaRecebimentoBeneficio,
              cartaoRmc: register.cartaoRmc,
              cartaoRcc: register.cartaoRcc,
              bancosCartaoRc: register.bancosCartaoRc,
              despachoAnoInicial: register.despachoAnoInicial ?? null,
              despachoAnoFinal: register.despachoAnoFinal ?? null,
              especies: register.especies,
              quantidadeEmprestimo: register.quantidadeEmprestimo,
              quantidadeInicialEmprestimo: register.quantidadeInicialEmprestimo,
              quantidadeFinalEmprestimo: register.quantidadeFinalEmprestimo,
              salario: register.salario,
              quantidadeInicialSalario: quantidadeInicialSalario,
              quantidadeFinalSalario: quantidadeFinalSalario,
              margemLivre: register.margemLivre,
              quantidadeInicialMargem: Number(
                removeMaskMoney(register.quantidadeInicialMargem)
              ),
              quantidadeFinalMargem: Number(
                removeMaskMoney(register.quantidadeFinalMargem)
              ),
              margemCartao: register.margemCartao,
              quantidadeInicialMargemCartao: Number(
                removeMaskMoney(register.quantidadeInicialMargemCartao)
              ),
              quantidadeFinalMargemCartao: Number(
                removeMaskMoney(register.quantidadeFinalMargemCartao)
              ),
              representanteLegal: register.representanteLegal
            },
            { abortEarly: false }
          )
          .then(() => {
            schemaTab3
              .validate(
                {
                  bancosPagadoresConsiderarCampanha:
                    register.bancosPagadoresConsiderarCampanha
                },
                { abortEarly: false }
              )
              .then(() => {
                schemaTab4
                  .validate(
                    {
                      instituicaoFinanceiraCampanha:
                        register.instituicaoFinanceiraCampanha,
                      parcelas: register.parcelas,
                      quantidadeInicialParcelas:
                        register.quantidadeInicialParcelas,
                      quantidadeFinalParcelas: register.quantidadeFinalParcelas,
                      valorParcela: register.valorParcela,
                      quantidadeInicialValorParcela: Number(
                        removeMaskMoney(register.quantidadeInicialValorParcela)
                      ),
                      quantidadeFinalValorParcela: Number(
                        removeMaskMoney(register.quantidadeFinalValorParcela)
                      )
                    },
                    { abortEarly: false }
                  )
                  .then(() => {
                    if (isTipoElevenLabs) {
                      schemaTab6
                        .validate(
                          {
                            agenteVoz: register.agentesElevenLabsId,
                            numerosOrigemElevenLabsId:
                              register.numerosOrigemElevenLabsId,
                            tempoLimiteToque: register.tempoLimiteToque,
                            limiteConcorrencia: register.limiteConcorrencia
                          },
                          { abortEarly: false }
                        )
                        .then(() => {
                          iniciarFluxoSalvarCampanha()
                        })
                        .catch((err) => {
                          err.inner.forEach((e: yup.ValidationError) => {
                            const fieldName =
                              e.path === 'numerosOrigemElevenLabsId'
                                ? 'numeroOrigemElevenLabsId'
                                : e.path || ''

                            dispatch(
                              campanhaActions.setInvalidsTabDiscador(
                                true,
                                fieldName
                              )
                            )
                          })
                          toast.warn(
                            'Preencha todos os campos corretamente da Aba "Parâmetros ElevenLabs" para salvar!'
                          )
                          dispatch(campanhaActions.setActiveTabRegister(6))
                        })
                    } else if (isTipoDiscadorOuUra) {
                      schemaTab5
                        .validate(
                          {
                            tiposCampanhaId: register.tipoCampanhaCrmId,
                            horaInicio:
                              register.campanhaCrmParametrosDiscador.horaInicio,
                            horaFim:
                              register.campanhaCrmParametrosDiscador.horaFim,
                            pergunta:
                              register.campanhaCrmParametrosDiscador.pergunta
                          },
                          { abortEarly: false }
                        )
                        .then(() => {
                          iniciarFluxoSalvarCampanha()
                        })
                        .catch((err) => {
                          err.inner.forEach((e: yup.ValidationError) => {
                            dispatch(
                              campanhaActions.setInvalidsTabDiscador(
                                true,
                                e.path || ''
                              )
                            )
                          })
                          toast.warn(
                            'Preencha todos os campos corretamente da Aba "Parâmetros Discador / URA" para salvar!'
                          )
                          dispatch(campanhaActions.setActiveTabRegister(5))
                        })
                    } else {
                      iniciarFluxoSalvarCampanha()
                    }
                  })
                  .catch((err) => {
                    err.inner.forEach((e: yup.ValidationError) => {
                      dispatch(
                        campanhaActions.setInvalidsTabRefinPortabilidade(
                          true,
                          e.path || ''
                        )
                      )
                    })
                    toast.warn(
                      'Preencha todos os campos corretamente da Aba "REFIN/Portabilidade" para salvar!'
                    )
                    dispatch(campanhaActions.setActiveTabRegister(4))
                  })
              })
              .catch((err) => {
                err.inner.forEach((e: yup.ValidationError) => {
                  dispatch(
                    campanhaActions.setInvalidsTabBancos(true, e.path || '')
                  )
                })
                toast.warn(
                  'Preencha todos os campos corretamente da Aba "Bancos Pagadores" para salvar!'
                )
                dispatch(campanhaActions.setActiveTabRegister(3))
              })
          })
          .catch((err) => {
            err.inner.forEach((e: yup.ValidationError) => {
              dispatch(
                campanhaActions.setInvalidsTabParametros(true, e.path || '')
              )
            })
            toast.warn(
              'Preencha todos os campos corretamente da Aba "Parâmetros" para salvar!'
            )
            dispatch(campanhaActions.setActiveTabRegister(2))
          })
      })
      .catch((err) => {
        let possuiErroBaseDados = false

        err.inner.forEach((e: yup.ValidationError) => {
          if (e.path === 'basePropria') {
            possuiErroBaseDados = true
            dispatch(
              campanhaActions.setInvalidsTabDadosGerais(true, 'basePropria')
            )
            dispatch(
              campanhaActions.setInvalidsTabDadosGerais(true, 'carteira')
            )
            return
          }

          dispatch(
            campanhaActions.setInvalidsTabDadosGerais(true, e.path || '')
          )
        })

        if (possuiErroBaseDados) {
          toast.warn(
            'Selecione uma base de dados: Base própria ou Consignado rápido.'
          )
        } else {
          toast.warn(
            'Preencha todos os campos corretamente da Aba "Dados Gerais" para salvar!'
          )
        }

        dispatch(campanhaActions.setActiveTabRegister(1))
      })
  }

  function abrirModalPreviaLayout() {
    dispatch(campanhaActions.getPreviaClientesPorLojaSaga())
  }

  function executarSalvarCampanha() {
    if (register.id) {
      dispatch(campanhaActions.atualizarCampanhaSaga())
    } else {
      dispatch(campanhaActions.criarCampanhaSaga())
    }
  }

  function iniciarFluxoSalvarCampanha() {
    if (register.basePropria) {
      abrirModalPreviaLayout()
      return
    }

    executarSalvarCampanha()
  }

  function aprovarESalvarCampanha() {
    dispatch(campanhaActions.toggleModalAprovacaoClientes(false))
    executarSalvarCampanha()
  }

  function confirmarAprovacaoComPrevia() {
    if (todosSemClientes) {
      return
    }

    if (possuiPreviaMista) {
      setShowConfirmacaoParcialSemClientes(true)
      return
    }

    aprovarESalvarCampanha()
  }

  function reprovarSalvarCampanha() {
    dispatch(campanhaActions.toggleModalAprovacaoClientes(false))
    dispatch(campanhaActions.cleanPreviaClientesPorLoja())
  }

  function voltaParaSearch() {
    dispatch(campanhaActions.toggleModalAprovacaoClientes(false))
    dispatch(campanhaActions.cleanPreviaClientesPorLoja())
    dispatch(campanhaActions.cleanRegister())
    cleanAllInvalids()
    dispatch(campanhaActions.setVisualizacao(false))
    dispatch(campanhaActions.setActiveTabRegister(1))
    dispatch(campanhaActions.setActiveTab('search'))
  }

  return (
    <SimpleCard className="d-flex flex-column row-gap-10">
      <Row>
        <Col md={6} className="d-flex">
          <CustomButton
            background="#662d90"
            letterSpacing={1}
            onClick={() => {
              voltaParaSearch()
            }}
          >
            Voltar
          </CustomButton>
        </Col>
        {!visualizacao && !isEdicaoCampanhaElevenLabs && (
          <Col className="d-flex justify-content-end" md={6}>
            <CustomButton
              onClick={() => {
                onSave()
              }}
            >
              Salvar
            </CustomButton>
          </Col>
        )}
      </Row>

      <Ul id="tabs" className="nav mb-2" data-tabs="tabs">
        <Tab>
          <a
            onClick={() => {
              dispatch(campanhaActions.setActiveTabRegister(1))
            }}
            className={classNames(activeTabRegister === 1 && 'active')}
            role="button"
          >
            <span className="fw-bold">Dados Gerais</span>
          </a>
        </Tab>
        <Tab>
          <a
            onClick={() => {
              dispatch(campanhaActions.setActiveTabRegister(2))
            }}
            className={classNames(activeTabRegister === 2 && 'active')}
            role="button"
          >
            <span className="fw-bold">Parâmetros</span>
          </a>
        </Tab>
        <Tab>
          <a
            onClick={() => {
              dispatch(campanhaActions.setActiveTabRegister(3))
            }}
            className={classNames(activeTabRegister === 3 && 'active')}
            role="button"
          >
            <span className="fw-bold">Bancos</span>
          </a>
        </Tab>
        <Tab>
          <a
            onClick={() => {
              dispatch(campanhaActions.setActiveTabRegister(4))
            }}
            className={classNames(activeTabRegister === 4 && 'active')}
            role="button"
          >
            <span className="fw-bold">REFIN/Portabilidade</span>
          </a>
        </Tab>
        {isTipoDiscadorOuUra && (
          <Tab>
            <a
              onClick={() => {
                dispatch(campanhaActions.setActiveTabRegister(5))
              }}
              className={classNames(activeTabRegister === 5 && 'active')}
              role="button"
            >
              <span className="fw-bold"> Parâmetros Discador / URA</span>
            </a>
          </Tab>
        )}
        {isTipoElevenLabs && (
          <Tab>
            <a
              onClick={() => {
                dispatch(campanhaActions.setActiveTabRegister(6))
              }}
              className={classNames(activeTabRegister === 6 && 'active')}
              role="button"
            >
              <span className="fw-bold">Parâmetros ElevenLabs</span>
            </a>
          </Tab>
        )}
      </Ul>
      <TabContent activeTab={activeTabRegister}>
        <TabPane tabId={1}>
          <div className="d-flex flex-column row-gap-10">
            <Campanha />
            <Localizacao />
          </div>
        </TabPane>
        <TabPane tabId={2}>
          <div className="d-flex flex-column row-gap-10">
            <Parametros />
            <MaisInformacoes />
          </div>
        </TabPane>
        <TabPane tabId={3}>
          <div className="d-flex flex-column row-gap-10">
            <BancosPagadores />
          </div>
        </TabPane>
        <TabPane tabId={4}>
          <div className="d-flex flex-column row-gap-10">
            <RefinanciamentoPortabilidade />
          </div>
        </TabPane>
        <TabPane tabId={5}>
          <div className="d-flex flex-column row-gap-10">
            <Discador />
          </div>
        </TabPane>
        <TabPane tabId={6}>
          <div className="d-flex flex-column row-gap-10">
            <ElevenLabs />
          </div>
        </TabPane>
      </TabContent>

      <ModalAprovacaoClientes
        isOpen={modalAprovacaoClientes}
        totalClientes={totalClientesPrevia}
        clientesPorLoja={previaClientesPorLoja}
        onReprovar={reprovarSalvarCampanha}
        onAprovar={confirmarAprovacaoComPrevia}
        disableAprovar={todosSemClientes}
        showAvisoPreviaMista={possuiPreviaMista}
      />

      <ModalConfirmacao
        isOpen={showConfirmacaoParcialSemClientes}
        toggle={setShowConfirmacaoParcialSemClientes}
        onConfirm={aprovarESalvarCampanha}
      >
        <p>
          Existem lojas/grupos sem clientes. Ao aprovar, esses itens serão
          desconsiderados. Deseja continuar?
        </p>
      </ModalConfirmacao>
    </SimpleCard>
  )
}
export default Register
